<template>
  <div class="ol-left-panel">
    <CompanyInfoOpportunity
      :business="opportunity.business"
      :business_apollo="opportunity.business_apollo"
    />

    <!-- Comercial asignado + empresa cliente (permissionFront) -->
    <div v-if="permissionFront()" class="section">
      <div class="section-title">
        <i class="icon-user"></i>
        {{ $t("lang.opportunities.left_panel_assigned_sales") }}
      </div>

      <template v-if="opportunity.link.userBilling">
        <div class="commercial-card">
          <div
            v-if="commercialAvatarUrl"
            class="commercial-avatar"
            :style="{ backgroundImage: 'url(' + commercialAvatarUrl + ')' }"
          ></div>
          <div v-else class="commercial-avatar commercial-avatar--initials">
            {{ commercialInitials }}
          </div>
          <div class="commercial-info">
            <div class="commercial-name">
              {{ opportunity.link.userBilling.name }}
              {{ opportunity.link.userBilling.lastname }}
            </div>
            <div class="commercial-email">{{ opportunity.link.userBilling.email }}</div>
          </div>
        </div>

        <div v-if="opportunity.link.userBilling.phone" class="team-detail-row mt-2">
          <i class="icon-phone"></i>
          <span class="team-detail-value">{{ opportunity.link.userBilling.phone }}</span>
          <button
            type="button"
            class="copy-inline"
            :title="$t('lang.general.copytoclipboard')"
            @click="copyClipboard(opportunity.link.userBilling.phone)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>

        <div v-if="currentUser.role_id == 1 || currentUser.role_id == 4" class="mt-2">
          <button
            type="button"
            class="team-rdv-btn w-100"
            :disabled="loadingManagerEvents"
            @click="$emit('open-manager-calendar-events')"
          >
            <i class="icon-calendar mr-1"></i>
            {{ loadingManagerEvents ? $t("lang.opportunities.left_panel_loading") : $t("lang.opportunities.left_panel_watch_manager_events") }}
          </button>
        </div>
      </template>

      <!-- Empresa cliente -->
      <div v-if="clientStatusIsVisible" class="client-company mt-3">
        <div class="client-company-label">
          <i class="icon-building"></i>
          {{ $t("lang.opportunities.left_panel_client_company") }}
        </div>
        <div class="client-company-card">
          <div class="client-company-head">
            <div
            v-if="commercialAvatarUrl"
            class="commercial-avatar"
            :style="{ backgroundImage: 'url(' + commercialAvatarUrl + ')' }"
            ></div>
            <div v-else class="commercial-avatar commercial-avatar--initials">
              {{ commercialInitials }}
            </div>
            <div class="client-company-identity">
              <div class="client-company-name">
                <span class="text-primary cursor-pointer" @click="goToClient(opportunity.link.client_id)">{{ opportunity.link.c_name }}</span>
                <span class="client-status-badge">
                  <span class="client-status-dot"></span>
                  {{ clientStatusText }}
                </span>
              </div>
            </div>
          </div>
          <div v-if="clientShortDescription" class="client-company-description">
            <p class="client-company-sector">
              {{ clientDescriptionDisplay }}
            </p>
            <button
              v-if="clientDescriptionIsLong"
              type="button"
              class="client-description-toggle"
              @click="clientDescriptionExpanded = !clientDescriptionExpanded"
            >
              {{ clientDescriptionExpanded ? $t("lang.opportunities.left_panel_read_less") : $t("lang.opportunities.left_panel_read_more") }}
              <i :class="clientDescriptionExpanded ? 'icon-angle-up' : 'icon-angle-down'"></i>
            </button>
          </div>
          <div class="client-company-details">
            <div v-if="opportunity.link.website" class="team-detail-row">
              <i class="icon-desktop"></i>
              <a
                class="text-primary flex-grow-1 text-truncate client-website-link"
                target="_blank"
                rel="noopener noreferrer"
                :href="getWebsiteUrl(opportunity.link.website)"
              >
                {{ opportunity.link.website }}
              </a>
              <button
                type="button"
                class="copy-inline"
                :title="$t('lang.general.copytoclipboard')"
                @click="copyClipboard(opportunity.link.website)"
              >
                <i class="icon-copy"></i>
              </button>
            </div>
            <div v-if="opportunity.link.client_address" class="team-detail-row">
              <i class="icon-location"></i>
              <span class="team-detail-value team-detail-value--wrap">{{ opportunity.link.client_address }}</span>
            </div>
            <div v-if="opportunity.link.num_employes" class="team-detail-row">
              <i class="icon-users"></i>
              <span class="team-detail-value">{{ opportunity.link.num_employes }}</span>
            </div>
            <!-- primary_phone: conservado para un posible uso futuro en este bloque -->
            <!-- <div v-if="opportunity.link.primary_phone" class="team-detail-row">
              <i class="icon-phone"></i>
              <span class="team-detail-value">{{ opportunity.link.primary_phone }}</span>
            </div> -->
          </div>
        </div>
      </div>

      <!--
        Sale Team / Oliverlist Business Developer / Campaña: aún no integrados en el nuevo diseño.
        Se mantienen comentados hasta decidir su ubicación en la columna izquierda.
      -->
      <!--
      <h6 class="my-3 font-weight-bold pl-2">Sale Team</h6>
      <small class="mb-2 pl-2">
        <i class="icon-user mr-2"></i>
        {{ opportunity.link.owner_name }} ({{ opportunity.link.cn_email }})
      </small>
      <template v-if="opportunity.link">
        <h6 class="my-3 font-weight-bold pl-2">Oliverlist Business Developer</h6>
        <small class="mb-2 pl-2">
          <i class="icon-user mr-2"></i>
          {{ opportunity.link.label_from }} ({{ opportunity.link.email }})
        </small>
        <div class="my-1 pl-2">
          <span class="w-100 cursor-pointer btn-primary btn text-white" @click="$emit('open-modal', 'calendar', true)">
            <i class="icon-calendar mr-1"></i>Calendar
          </span>
        </div>
        <h6 class="mt-3 pl-2 font-weight-bold">{{ $t("lang.column.campaign") }}</h6>
        <small class="pl-2">{{ opportunity.link.campaign_name }}</small>
      </template>
      -->
    </div>

    <!--
      Vista owner (permissionFront false): aún no integrada en el nuevo diseño.
      Se mantiene comentada hasta una decisión de producto.
    -->
    <!--
    <div v-if="!permissionFront()" class="section">
      <h6 class="mb-1">{{ $t("lang.column.owner") }}</h6>
      <small>{{ opportunity.link.owner_name }} ({{ opportunity.link.cn_email }})</small>
    </div>
    -->

    <!-- Pedido vinculado -->
    <div
      v-if="opportunity.link.target_id && hasPermissions('AgencyBilling')"
      class="section"
    >
      <div class="section-title">
        <i class="icon-folder"></i>
        {{ $t("lang.opportunities.left_panel_linked_order") }}
      </div>
      <a
        class="order-card"
        target="_blank"
        :href="'/orders/' + opportunity.link.target_id"
      >
        <div class="order-icon">
          <i class="icon-folder"></i>
        </div>
        <div class="order-info">
          <div class="order-label">{{ $t("lang.label.order") }}</div>
          <div class="order-ref">{{ opportunity.link.target_name }}</div>
        </div>
        <i class="icon-angle-right order-chevron"></i>
      </a>
    </div>

    <!-- Teléfonos y contactos -->
    <div class="section section--contacts">
      <OpportunityContact
        :business="opportunity.business"
        :business-contacts="opportunity.business_contacts"
        :link="opportunity.link"
        :status="opportunity.status"
        :unlocked="opportunity.unlocked"
        @unlock-contacts="$emit('unlock-contacts', $event)"
        @changeBusinessContactStatusByLinkId="$emit('changeBusinessContactStatusByLinkId', $event)"
        @unsubscribeContact="$emit('unsubscribeContact', $event)"
      />

      <button
        v-if="
          (!hasPermissions('adminClients') &&
            (adminTeam() || !permissionFront())) ||
          currentUser.role_id == 1
        "
        type="button"
        class="add-contact-btn"
        @click="$emit('open-modal', 'newcontact')"
      >
        <i class="icon-plus"></i>
        {{ $t("lang.label.addcontacts") }}
      </button>
    </div>

    <!-- Pie de página: acciones -->
    <div v-if="showAbsentButton || showMoreOptionsMenu" class="actions-footer">
      <button
        v-if="showAbsentButton"
        type="button"
        class="btn-action btn-action--primary"
        :disabled="opportunity.link.activeabsent == '1' || meetingInClaim == 1"
        @click="$emit('open-modal', 'absent')"
      >
        <Tooltip
          class="text-center w-100"
          :text="
            opportunity.link.activeabsent == '1'
              ? $t('lang.opportunities.absent')
                : meetingInClaim == 1
                  ? $t('lang.opportunities.claim_revision')
                  : ''
          "
          :width="'auto'"
        >
          <span class="d-inline-flex align-items-center justify-content-center">
            <i class="icon-calendar mr-1"></i>
            {{ $t("lang.refuse.absent") }}
          </span>
        </Tooltip>
      </button>

      <div
        v-if="showMoreOptionsMenu"
        class="dropdown-wrapper"
      >
        <button
          type="button"
          class="btn-action btn-action--secondary"
          :aria-label="$t('lang.opportunities.left_panel_more_options')"
          @click.stop="moreMenuOpen = !moreMenuOpen"
        >
          <i class="icon-ellipsis-v"></i>
        </button>
        <div class="ol-more-menu" :class="{ show: moreMenuOpen }">
          <button
            v-if="
              opportunity.link.link_status_reason_id == 34 ||
              opportunity.link.link_status_reason_id == 35
            "
            type="button"
            class="dropdown-item"
            @click="
              moreMenuOpen = false;
              $emit('valide');
            "
          >
            <div class="dropdown-item-text">
              <div class="dropdown-item-title">{{ $t("lang.label.setasvalidopportunity") }}</div>
            </div>
          </button>
          <div
            v-if="
              (opportunity.link.link_status_reason_id == 34 ||
                opportunity.link.link_status_reason_id == 35) &&
              showRefuseInMenu
            "
            class="dropdown-divider"
          ></div>
          <Tooltip
            v-if="showRefuseInMenu"
            :text="opportunity.link.activerefuse == '1' ? $t('lang.opportunities.refuse') : ''"
            :width="'auto'"
          >
            <button
              type="button"
              class="dropdown-item dropdown-item--danger w-100"
              :disabled="opportunity.link.activerefuse == '1' || !loadEvent"
              @click="
                moreMenuOpen = false;
                $emit('check-refuse');
              "
            >
              <i class="icon-flag"></i>
              <div class="dropdown-item-text">
                <div class="dropdown-item-title">{{ $t("lang.refuse.button") }}</div>
                <div class="dropdown-item-sub">{{ $t("lang.opportunities.left_panel_meeting_issue") }}</div>
              </div>
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyInfoOpportunity from "@/components/Opportunities/CompanyInfoOpportunity.vue";
import OpportunityContact from "@/components/Common/OpportunityContact.vue";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  name: "OpportunityLeftPanel",
  components: {
    CompanyInfoOpportunity,
    OpportunityContact,
    Tooltip,
  },
  props: {
    opportunity: {
      type: Object,
      required: true,
    },
    currentUser: {
      type: Object,
      required: true,
    },
    loadEvent: {
      type: Boolean,
      default: false,
    },
    meetingInClaim: {
      type: [Number, String, null],
      default: null,
    },
    loadingManagerEvents: {
      type: Boolean,
      default: false,
    },
    clientStatusIsVisible: {
      type: Boolean,
      default: false,
    },
    clientStatusText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      moreMenuOpen: false,
      clientDescriptionExpanded: false,
      clientDescriptionCharLimit: 100,
      personPlaceholder:
        "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMyIiB3aWR0aD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSIxNiIgZmlsbD0iIzkwY2FmOSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iMTIiIHI9IjUiIGZpbGw9IndoaXRlIi8+PHBhdGggZD0iTTE2IDE4Yy02LjYgMC0xMiA0LjItMTIgOXYxYzAgMS4xLjkgMiAyIDJoMjhjMS4xIDAgMi0uOSAyLTJ2LTFjMC00LjgtNS40LTktMTItOXoiIGZpbGw9IndoaXRlIi8+PC9zdmc+",
    };
  },
  computed: {
    showAbsentButton() {
      return (
        !this.hasPermissions("adminClients") &&
        (this.adminTeam() || !this.permissionFront()) &&
        !(
          this.opportunity.link.link_status_reason_id == 34 ||
          this.opportunity.link.link_status_reason_id == 35
        )
      );
    },
    showRefuseInMenu() {
      return this.showAbsentButton;
    },
    showMoreOptionsMenu() {
      const validateVisible =
        this.opportunity.link.link_status_reason_id == 34 ||
        this.opportunity.link.link_status_reason_id == 35;
      return validateVisible || this.showRefuseInMenu;
    },
    clientShortDescription() {
      const text = this.opportunity.link.short_description;
      return text ? String(text).trim() : "";
    },
    clientDescriptionIsLong() {
      return this.clientShortDescription.length > this.clientDescriptionCharLimit;
    },
    clientDescriptionDisplay() {
      if (
        this.clientDescriptionExpanded ||
        !this.clientDescriptionIsLong
      ) {
        return this.clientShortDescription;
      }
      return (
        this.clientShortDescription.substring(0, this.clientDescriptionCharLimit) +
        "..."
      );
    },
    commercialBillingFullName() {
      const billing = this.opportunity.link.userBilling;
      if (!billing) {
        return "";
      }
      return [billing.name, billing.lastname].filter(Boolean).join(" ");
    },
    commercialAvatarUrl() {
      const billing = this.opportunity.link.userBilling;
      if (!billing) {
        return "";
      }
      const avatar = billing.avatar;
      if (avatar == null || avatar === "") {
        return "";
      }
      const trimmed = String(avatar).trim();
      return trimmed || "";
    },
    commercialInitials() {
      return this.getPersonInitials(this.commercialBillingFullName);
    },
  },
  watch: {
    "opportunity.link.id"() {
      this.clientDescriptionExpanded = false;
    },
  },
  mounted() {
    document.addEventListener("click", this.closeMoreMenuOnOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeMoreMenuOnOutsideClick);
  },
  methods: {
    closeMoreMenuOnOutsideClick(e) {
      if (!this.$el.contains(e.target)) {
        this.moreMenuOpen = false;
      }
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    permissionFront() {
      return (
        this.currentUser.team_role_id == undefined ||
        this.currentUser.team_role_id != 3
      );
    },
    adminTeam() {
      return (
        this.currentUser.team_role_id != undefined &&
        this.currentUser.team_role_id == 2
      );
    },
    getWebsiteUrl(website) {
      if (!website) {
        return "";
      }
      const trimmed = String(website).trim();
      if (!trimmed) {
        return "";
      }
      if (trimmed.includes("http")) {
        return trimmed;
      }
      return "https://" + trimmed;
    },
    getPersonInitials(name) {
      if (!name || typeof name !== "string") {
        return "?";
      }
      const trimmed = name.trim();
      if (!trimmed || trimmed.indexOf("@") !== -1) {
        return "?";
      }
      return trimmed
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.charAt(0))
        .join("")
        .substring(0, 2)
        .toUpperCase();
    },
    copyClipboard(text) {
      if (!text) return;
      if (window.clipboardData && window.clipboardData.setData) {
        return window.clipboardData.setData("Text", text);
      }
      if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        const textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand("copy");
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },
    goToClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.ol-left-panel {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
}

.section {
  padding: 14px 18px;
  border-bottom: 1px solid #f4f4f7;
}

.section--contacts {
  padding-bottom: 10px;
}

.section-title {
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.commercial-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f7f7fe;
  border: 1px solid #eeeefc;
  border-radius: 10px;
}

.commercial-avatar,
.client-company-logo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex-shrink: 0;
}

.commercial-avatar--initials {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #4b4be1;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
}

.client-company-logo {
  border-radius: 9px;
  border: 1px solid #e5e7eb;
  background-color: white;
}

.commercial-info {
  flex: 1;
  min-width: 0;
}

.commercial-name {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
}

.commercial-email {
  font-size: 11px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-detail-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #374151;
}

.team-detail-row > i {
  color: #9ca3af;
  flex-shrink: 0;
}

.team-detail-value {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.client-website-link {
  font-size: 12px;
  min-width: 0;
}

.client-website-link:hover {
  text-decoration: underline;
}

.team-detail-value--wrap {
  white-space: normal;
}

.copy-inline {
  background: none;
  border: none;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
  color: #9ca3af;
}

.copy-inline:hover {
  background: #f4f4f7;
  color: #374151;
}

.team-rdv-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 7px;
  background: #fafafb;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  color: #374151;
  font-size: 11px;
  font-weight: 500;
}

.team-rdv-btn:hover:not(:disabled) {
  border-color: #5054EB;
  color: #5054EB;
  background: #f7f7fe;
}

.client-company-label {
  font-size: 10px;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.client-company-card {
  background: #fafafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
}

.client-company-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.client-company-identity {
  flex: 1;
  min-width: 0;
}

.client-company-name {
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.client-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 500;
  color: #065f46;
  background: #d1fae5;
  padding: 1px 7px;
  border-radius: 4px;
}

.client-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10b981;
}

.client-company-description {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-left: 0;
  margin-left: 0;
}

.client-company-sector {
  font-size: 10px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
}

.client-description-toggle {
  margin-top: 0px;
  margin-left: auto;
  align-self: flex-end;
  background: none;
  border: none;
  color: #5054EB;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.client-description-toggle:hover {
  color: #5054EB;
}

.client-company-details {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #fafafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  text-decoration: none;
  color: inherit;
  width: 100%;
}

.order-card:hover {
  border-color: #5054EB;
  background: #f7f7fe;
}

.order-icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: white;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5054EB;
  flex-shrink: 0;
}

.order-info {
  flex: 1;
  min-width: 0;
}

.order-label {
  font-size: 11px;
  color: #6b7280;
}

.order-ref {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
}

.order-chevron {
  color: #9ca3af;
  font-size: 16px;
}

.add-contact-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px;
  background: white;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}

.add-contact-btn:hover {
  border-color: #5054EB;
  color: #5054EB;
  background: #f7f7fe;
  border-style: solid;
}

.actions-footer {
  padding: 14px 18px;
  background: #fafafb;
  display: flex;
  align-items: stretch;
  gap: 8px;
  border-top: 1px solid #f4f4f7;
}

.btn-action {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-action--primary {
  background: #5054EB;
  color: white;
  border-color: #5054EB;
}

.btn-action--primary:hover:not(:disabled) {
  background: #5054EB;
}

.btn-action--primary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-action--secondary {
  flex: 0 0 auto;
  background: white;
  color: #374151;
  border-color: #e5e7eb;
  padding: 10px 12px;
  min-width: 44px;
  height: 100%;
}

.dropdown-wrapper {
  position: relative;
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  margin-left: auto;
}

.ol-more-menu {
  position: absolute;
  bottom: 100%;
  right: 0;
  left: auto;
  margin-bottom: 6px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  min-width: 240px;
  padding: 6px;
  display: none;
  z-index: 100;
}

.ol-more-menu.show {
  display: block;
}

.ol-more-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  border-radius: 7px;
  cursor: pointer;
  color: #374151;
  font-size: 13px;
}

.ol-more-menu .dropdown-item:hover:not(:disabled) {
  background: #fafafb;
}

.ol-more-menu .dropdown-item--danger {
  color: #ef4444;
}

.ol-more-menu .dropdown-item--danger:hover:not(:disabled) {
  background: #fee2e2;
}

.ol-more-menu .dropdown-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dropdown-item-title {
  font-size: 13px;
  font-weight: 500;
}

.dropdown-item-sub {
  font-size: 11px;
  color: #6b7280;
}

.dropdown-divider {
  height: 1px;
  background: #f4f4f7;
  margin: 4px 0;
}
</style>
